
const digest = 'fb87a886f69a700001ab75b3074a974f103e94f6d5d10c3462743dde16eaf35e';
const classes = {"wrapper":"_wrapper_17f40_1","button":"_button_17f40_4"};
const css = `._wrapper_17f40_1 {
  font-family: Rubik, "sans-serif";
}
._wrapper_17f40_1 ._button_17f40_4 {
  width: fit-content;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  